<template>
  <div>
    <ShowcaseEditDialog
      :state="editDialog"
      :selectedShowcase="selectedShowcase"
      @close="editDialog = false"
    />
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Sản phẩm học sinh"
          :link="[{ text: 'Sản phẩm học sinh', href: '../showcase' }]"
        />
      </div>
      <div v-if="canEdit">
        <showcase-list-actions :selected="selected" />
      </div>
    </div>
    <v-card class="pa-2 mx-md-2">
      <v-row class="justify-end px-2" no-gutters>
        <span v-if="$vuetify.breakpoint.smAndDown">
          <showcase-filter-dialog @onFilterChanged="refresh" />
        </span>
        <setting-table-header :default-headers="headers" @change="headers = $event" />
        <span v-if="$vuetify.breakpoint.mdAndUp">
          <kebap-menu>
            <v-list>
              <v-list-item>
                <export-excel :custom-header="headers" api="/classes/" />
              </v-list-item>
            </v-list>
          </kebap-menu>
        </span>
      </v-row>
      <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters>
        <showcase-filter @onFilterChanged="refresh"></showcase-filter>
      </v-row>
      <v-data-table
        item-key="id"
        class="px-2"
        v-model="selected"
        :headers="headers"
        :items="showcases"
        :items-per-page="5"
        :search="search"
        :loading="loading"
        :show-select="canEdit"
      >
        <template v-slot:item.root="{ item }">
          <p>{{ item.root | getRoot }}</p>
        </template>
        <template v-slot:item.image="{ item }">
          <v-img
            height="60"
            width="60"
            :src="getImage(item)"
            aspect-ratio="2"
            contain
            class="ma-1"
          ></v-img>
        </template>
        <template v-slot:item.action="{ item }" v-if="canEdit">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon dark>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="edit(item)">
                <v-list-item-title>
                  <v-icon class="mr-2">mdi-pencil</v-icon> Chỉnh sửa</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="remove(item)">
                <v-list-item-title>
                  <v-icon class="mr-2">mdi-delete</v-icon>
                  Xóa</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.major="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <router-link
                  v-if="item.major"
                  style="text-decoration: none; white-space: nowrap"
                  :to="`/major/${getMajor(item.major).id}`"
                  >{{ getMajor(item.major).code }}</router-link
                >
              </div>
            </template>
            <span>{{ getMajor(item.major).title }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ShowcaseFilter from '@/modules/showcase/ShowcaseFilter'
import ShowcaseListActions from '@/modules/showcase/ShowcaseListActions'
import ShowcaseFilterDialog from '@/modules/showcase/ShowcaseFilterDialog'
import ShowcaseEditDialog from '@/modules/showcase/ShowcaseEditDialog'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import ExportExcel from '@/components/basic/ExportExcel'
import KebapMenu from '@/components/basic/menu/KebapMenu'
import { get } from 'lodash'
export default {
  components: {
    ShowcaseListActions,
    ShowcaseFilterDialog,
    ShowcaseFilter,
    ShowcaseEditDialog,
    Breadcrumbs,
    SettingTableHeader,
    ExportExcel,
    KebapMenu
  },
  props: {
    role: String
  },
  data() {
    return {
      loading: false,
      selectedShowcase: {},
      editDialog: false,
      headers: [
        {
          text: 'Ảnh',
          value: 'image',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Tên',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Chuyên Ngành',
          value: 'major',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Mô Tả',
          value: 'description',
          align: 'left',
          sortable: false,
          show: false
        },
        {
          text: 'Hành Động',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true,
          width: 100
        }
      ],
      selected: [],
      draw: false,
      search: '',
      status: null,
      sortBy: 'updatedAt',
      sortDesc: true
    }
  },
  async created() {
    this.loading = true
    await this.fetchMajors({
      department: this.department.id
    })
    await this.fetchShowcases({
      department: this.department.id,
      position_ncontains: 'home-page'
    })
    this.selectedShowcase = this.showcases[0]
    this.loading = false
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapGetters('showcases', ['showcases', 'majors']),
    ...mapGetters('auth', ['role']),
    canEdit() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    }
  },
  methods: {
    ...mapActions('showcases', [
      'fetchShowcases',
      'fetchMajors',
      'removeShowcases',
      'removeShowcase',
      'updateShowcase',
      'destroyAvatar'
    ]),
    isHomepage(item) {
      return item.position && item.position.includes('home-page')
    },
    refresh(data) {
      const { major, position, search } = data
      let query = {}
      if (position) query.position = { $regex: `.*${position}.*` }
      if (major) query.major = major
      this.fetchShowcases({
        department: this.department.id,
        ...query,
        position_ncontains: 'home-page'
      })
      if (search) this.search = search
    },
    updateDraw(draw) {
      this.draw = draw
    },
    onShowcaseSelected(showcase) {
      this.setShowcase(showcase)
    },
    getPosition: position => {
      if (!position) return ''
      if (position.trim() === ',') return ''
      return position
    },
    getMajor: major => {
      return major || {}
    },
    getImage: item => {
      const imgUrl = get(item, 'image[0].url', 'https://cdn.vuetifyjs.com/images/cards/docks.jpg')
      if (!/^http/.test(imgUrl)) {
        return `${process.env.VUE_APP_API_ENDPOINT}${imgUrl}`
      } else {
        return imgUrl
      }
    },
    remove(item) {
      this.$dialog.confirm({
        title: 'Xóa sản phẩm',
        text: 'Bạn có chắc muốn xóa sản phẩm này của học sinh?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeShowcase(item.id)
          await this.destroyAvatar(item.image[0].id)
        }
      })
    },
    edit(item) {
      this.editDialog = true
      this.selectedShowcase = item
    },
    makeAvatar(item) {
      this.$dialog.confirm({
        title: 'Ảnh Đại Diện',
        text: `Bạn có chắc muốn đưa ảnh này làm ảnh đại diện chuyên ngành ${item.major.title}?`,
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          if (item.position.toLowerCase().indexOf('highlight') === -1) {
            await this.updateShowcase({
              id: item.id,
              createdAt: new Date().toISOString(),
              position: ['highlight', ...new Set([...(item.position || '').split(',')])].join(',')
            })
            this.$alert.success(`Để ảnh đại diện thành công!`)
            this.fetchShowcases({ department: this.department.id })
          } else {
            this.$alert.error(`Ảnh này đã được đặt làm ảnh đại diện từ trước!`)
          }
        }
      })
    }
  },
  filters: {
    getRoot(root) {
      return root ? root.title : ''
    }
  }
}
</script>
<style scoped>
.container {
  max-width: 100% !important;
}
</style>
